class LadaButton {
  constructor($element, FormService, $translate, $rootScope) {
    'ngInject';

    this.$element = $element;
    this.FormService = FormService;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
  }

  $onInit() {
    this.button = this.$element.find('button')[0];
    this.button.innerHTML = this.$translate.instant(this.text);
    this.button.classList.add(this.class);
    this.laddaInstance = Ladda.create(this.button);

    this.subscription = this.FormService.isSubmitting.subscribe((isSubmitting) => {
      if (!isSubmitting) {
        this.stop();
      }
    });

    this.$rootScope.$on('$translateChangeSuccess', () => {
      this.button.innerHTML = this.$translate.instant(this.text);
    });
  }

  $onChanges() {
    if (this.load !== null && this.load === false) {
      if (this.laddaInstance) {
        this.stop();
      }
    }
  }

  $onDestroy() {
    this.subscription.unsubscribe();
  }

  $doCheck() {
    if (this.laddaDisable) {
      this.button.setAttribute('disabled', 'disabled');
    } else {
      this.button.removeAttribute('disabled');
    }
  }

  stop() {
    this.laddaInstance.stop();
  }

  click() {
    this.laddaInstance.start();
    this.onClick();
  }
}

export default LadaButton;



// WEBPACK FOOTER //
// ./client/app/shared/ui/ladda-button/ladda-button.controller.js